<template>
  <section>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title m-subheader__title--separator">
            {{ 'sync_complete' | translate | capitalize }}
          </h3>
          <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
            <span><router-link :to="{name: 'support'}">{{'support' | translate | capitalize}}</router-link></span>
          </ul>
        </div>
      </div>
    </div>
    <div class="m-content" id="content">
      <div class="m-portlet">
        <div class="m-portlet__body">
          <div class="row">
            <div class="col-xl-5">
              <select v-model="property_id" id="property" name="property" class="form-control m-bootstrap-select m_selectpicker" :title="'select_an_option' | translate | capitalize" @change="searchSync">
                <option v-for="property in properties" :key="property.id" :value="property.id">{{ property.name }}</option>
              </select>
            </div>
            <div class="col-xl-5">
              <s-date-time-picker id="date" v-model="date" :options="config" :placeholder="'AAAA-MM-DD'" v-validate="'required'" @empty="end_date = $event"></s-date-time-picker>
            </div>
            <div class="col-xl-2 text-center">
              <button class="btn btn-primary" @click.prevent="searchSync">{{'search' | translate | capitalize}}</button>
            </div>
          </div>
        </div>
      </div>

      <h5 v-if="sites.length > 0" class="m-subheader__title m-subheader__title--separator">
        {{ 'sites' | translate | capitalize }}
      </h5>
      <div v-if="sites.length > 0" class="m-portlet sites col-cl-4">
        <div class="m-portlet__body  m-portlet__body--no-padding">
          <div class="row m-row--no-padding m-row--col-separator-xl">
            <div v-for="site in sites" :key="site.id" class="col-md-12 col-lg-6 col-xl-4 border-style cursor__pointer" @click="showEntities(site.sync_count)">
              <div class="m-widget24">					 
                <div class="m-widget24__item">
                  <h4 class="m-widget24__title m--font-warning">{{site.name}}</h4><br>
                  <span class="m-widget24__desc">{{'total_register' | translate | capitalize}}</span>
                  <span class="m-widget24__stats m--font-primary">{{site.total_count}}</span>		
                  <div class="m--space-10"></div>
                </div>				      
              </div>
            </div>
            <div v-for="(site, key) in sites_blank" :key="`${key}_site`" class="col-md-12 col-lg-6 col-xl-4 border-style">
              <div class="m-widget24 site-space">
                <img alt="" src="/media/img/logo_m.png" class="site-img">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="entities.length > 0" class="row">
        <div v-for="(column, key) in entities" :key="key" class="col-xl-4">
          <div class="m-portlet m-portlet--full-height ">
            <div class="m-portlet__body">
              <div class="m-widget4">
                <div v-for="entity in column" :key="entity.id" class="m-widget4__item">
                  <div class="m-widget4__info">
                    <span class="m-widget4__text">{{entity.entity}}</span>
                  </div>
                  <div class="m-widget4__ext">
                    <span class="m-widget4__number m--font-info">{{entity.count}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      properties: [],
      property_id: '',
      sites: [],
      entities: [],
      sites_blank: 0,
      date: moment().format('YYYY-MM-DD'),
      config: {
        format: 'yyyy-mm-dd',
        minView: 2,
        startDate: '',
        autoclose: true,
        pickerPosition: 'bottom-left'
      }
    }
  },
  created () {
    this.$spinner.show()
    this.getProperties().then((res) => {
      this.properties = res.data
      this.$nextTick(() => { window.$('.m_selectpicker').selectpicker('refresh') })
      this.$spinner.remove()
    })
  },
  methods: {
    ...mapActions(['getProperties', 'retrieveSites']),
    searchSync () {
      this.$spinner.show()
      this.retrieveSites({property: this.property_id, date: this.date}).then((res) => {
        this.sites = res.data
        this.entities = []
        this.addSpace()
        this.$spinner.remove()
      })
    },
    addSpace () {
      this.sites_blank = this.sites.length
      while (Math.sign(this.sites_blank) === 1) {
        this.sites_blank = this.sites_blank - 3
      }
      this.sites_blank = Math.abs(this.sites_blank)
    },
    showEntities (entities) {
      entities = JSON.parse(JSON.stringify(entities))
      let count = 0
      let result = []
      while (entities.length) {
        result[count] = entities.splice(0, 6)
        count++
      }
      this.entities = result
    }
  }
}
</script>

<style lang="sass" scoped>
.sites
  margin-top: 10px
.border-style
  border-right: 1px solid #ebedf2 !important
  border-bottom: .07rem dashed #ebedf2 !important
.cursor__pointer:hover
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12)
.cursor__pointer
  cursor: pointer
.site-space
  opacity: 0.4
  text-align: center
.site-img
  width: 100px
</style>



// WEBPACK FOOTER //
// SyncComplete.vue